import { $authHost } from ".."

// export const getSupplierTypesAPI = async () => {
//     const {data} = await $authHost.get(`api/suppliers/types`)
//     return data
// }

export const addCommentAPI = async (comment) => {
    const {data} = await $authHost.post(`api/comments/`, comment)
    return data
}

// export const editSupplierAPI = async (supplier) => {
//     const {data} = await $authHost.post(`api/suppliers/${supplier.id}`, supplier)
//     return data
// }

// export const getSuppliersAPI = async ({ offset, limit, query }) => {

//     let params = ''
//     if (query) {
//         params = `?query=${query}`
//     } else if ((offset || offset === 0) && limit) {
//         params = `?offset=${offset}&limit=${limit}`
//     }

//     const {data} = await $authHost.get(`api/suppliers/${params}`)
//     return data
// }